import React from "react";
import { AddressRegistrationTemplate } from "../../Templates/AddressRegistrationTemplate";

export const AddressRegistration = () => {
  return <AddressRegistrationTemplate />;
};
